require('../node_modules/vuetify/src/stylus/app.styl')

import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import {Auth} from './components/auth/cognito_auth'
import {store} from './store/store'

var AWS = require('aws-sdk/global');

AWS.config.region = process.env.VUE_APP_AWS_REGION;

Auth.init();

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
